
import VueAxios from "vue-axios";
import axios from "axios";
//Vue.use(VueAxios, axios);
//Vue.use(Vuex)
//const this.$store.state.baseapi = "http://127.0.0.1:8000/api/";
export default {
    data() {
      return {
       
      }
    },
  
    created() {
     
    },
  
    methods: {
     

     
     GET_INDICADOR_VALOR_VARIABLES: async function(data) {




      
      var result =  await axios
        ({
          method: 'GET',
          url: this.$store.state.baseapi+"sistema_municipios/"+data.idmunicipio+ "/serie/"+data.idserie+"/variables/"+data.idvariable+"/frecuencia/"+data.idfrecuencia+"/indicador_valor/" ,
          responseType: 'json', 
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          },
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },


/*GET_INDICADOR_VALOR_VARIABLES: async function(data) {




      
      var result =  await axios
        ({
          method: 'GET',
          url: this.$store.state.baseapi+"sistema_municipios/"+data.idmunicipio+"/indicador_valores_variables/" ,
          responseType: 'json', 
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          },
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },
 */





    CREAR_INDICADOR_VALOR_VARIABLES: async function(data) {



      
      var result =  await axios
        ({
          method: 'POST',
          url: this.$store.state.baseapi+"indicador_valores_variables/" ,
          responseType: 'json',
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          },
          data:{
            idmunicipio:data.idmunicipio,
          idserie:data.idserie,
          idfrecuencia:data.idfrecuencia,
          idvariable:data.idvariable,
      
          enero:data.enero, 
          febrero:data.febrero, 
          marzo:data.marzo, 
 
          abril:data.abril, 
          mayo:data.mayo, 
          junio:data.junio, 
 
              
          julio:data.julio, 
          agosto:data.agosto, 
          septiembre:data.septiembre, 
 
              
          octubre:data.octubre, 
          noviembre:data.noviembre, 
          diciembre:data.diciembre, 
 
          idsecretaria:data.idsecretaria, 
          iddepartamento:data.iddepartamento,  
              
               
          }
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },





    EDITAR_INDICADOR_VALOR_VARIABLES: async function(data) {




      
      var result =  await axios
        ({
          method: 'PUT',
          url: this.$store.state.baseapi+"indicador_valores_variables/"+data.id ,
          responseType: 'json',
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          },
          data:{
            idmunicipio:data.idmunicipio,
            idserie:data.idserie,
            idfrecuencia:data.idfrecuencia,
            idvariable:data.idvariable,
        
            'enero':data.enero, 
            'febrero':data.febrero, 
            'marzo':data.marzo, 
   
            'abril':data.abril, 
            'mayo':data.mayo, 
            'junio':data.junio, 
   
                
            'julio':data.julio, 
            'agosto':data.agosto, 
            'septiembre':data.septiembre, 
   
                
            'octubre':data.octubre, 
            'noviembre':data.noviembre, 
            'diciembre':data.diciembre, 
              
            
          }
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },

    ELIMINAR_INDICADOR_VALOR_VARIABLES: async function(data) {




      
      var result =  await axios
        ({
          method: 'delete',
          url: this.$store.state.baseapi+"indicador_valores_variables/"+data.id ,
          responseType: 'json',
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          }
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },
    },
  }